import { useEffect, useState } from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { Outlet, useLocation } from 'react-router';

import Container from 'components/Container';
import Sidebar from 'components/Sidebar';
import Topbar from 'components/Topbar';

interface PropTypes {
  navBarItems: Array<NavItem | NavDropDown>;
  // colorInvert?: boolean;
  // bgcolor?: string;
}

export function MainLayout({ navBarItems = [] }: PropTypes): JSX.Element {
  const bgcolor = 'transparent';
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const { hash, pathname } = useLocation();
  const invertNavbarColor = ['/about'].includes(location.pathname.toLowerCase());

  const [openSidebar, setOpenSidebar] = useState(false);

  // effect to scroll to top when the route changes
  useEffect(() => {
    // if hash is present, scroll to the element
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      requestAnimationFrame(() => el?.scrollIntoView({ behavior: 'smooth' }));
      return;
    }

    // otherwise scroll to the top
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  const handleSidebarOpen = (): void => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = (): void => {
    setOpenSidebar(false);
  };

  const open = isMd ? false : openSidebar;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return (
    // main flex container
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <AppBar
        position={'sticky'}
        sx={{
          top: 0,
          backgroundColor: trigger ? theme.palette.background.paper : bgcolor,
        }}
        elevation={trigger ? 1 : 0}
      >
        <Container paddingY={1}>
          <Topbar
            toggleSidebar={handleSidebarOpen}
            navItems={navBarItems}
            colorInvert={trigger ? false : invertNavbarColor}
          />
        </Container>
      </AppBar>
      <Sidebar onClose={handleSidebarClose} open={open} variant="temporary" navItems={navBarItems} />
      <Box component="main" display="contents">
        <Outlet />
      </Box>
      {/* <Container paddingY={4}>
        <Footer />
      </Container> */}
    </Box>
  );
}

export default MainLayout;
